import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from "@persian-tools/persian-mobile-datepicker";
import DatePicker from "@amir04lm26/react-modern-calendar-date-picker";
import { toastOptions } from "../../../features/toast/toast";

const BASE_URL = "https://1x88.ir:8991";

const config: DatePickerConfig = {
    year: { caption: { text: "سال" } },
    month: { caption: { text: "ماه" } },
    day: { caption: { text: "روز" } },
};

const LogAdmin = () => {
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        formState: { errors },
    } = useForm();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [loading, setLoading] = useState(false);
    const [showPicker, setShowPicker] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
    const [selectedPcDate, setSelectedPcDate] = useState<any>(null);
    const [selectedDateValue, setSelectedDateValue] = useState<string>();

    // گرفتن کد ملی و موبایل از URL
    useEffect(() => {
        const nationalCode = queryParams.get("nationalCode");
        const mobile = queryParams.get("mobile");

        if (nationalCode) {
            setValue("nationalCode", nationalCode);
        }
        if (mobile) {
            setValue("mobile", mobile);
        }
    }, [location.search, setValue]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1024);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // تاریخ موبایل
    const handleMobileSubmit = (selectedDate: any) => {
        if (!selectedDate || !selectedDate.date) return;
        const date = format(selectedDate.date, "yyyyMMdd");
        setSelectedDateValue(date);
        setValue("birthDate", date, { shouldValidate: true });
    };

    const handlePcDateChange = (date: any) => {
        if (!date) return;
        const formatted = `${date.year}${String(date.month).padStart(2, "0")}${String(date.day).padStart(2, "0")}`;
        setSelectedPcDate(date);
        setSelectedDateValue(formatted);
        setValue("birthDate", formatted, { shouldValidate: true });
    };

    const onSubmit = async (data: any) => {
        setLoading(true);
        try {
            const res: any = await axios.post(
                `${BASE_URL}/api/Pose/PartnerRegister`,
                data,
            );
            if (res?.data?.statusCode == 200) {
                toast.success("شریکت تجاری ثبت شد", toastOptions);
            }
            else {
                toast.error(res?.data?.message, toastOptions);
            }
        } catch (err: any) {
            toast.error(err?.response?.data?.message || "خطا در ثبت اطلاعات");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container">
            <div className="row justify-content-center py-4">
                <div className="col-lg-4 col-md-6">
                    <form onSubmit={handleSubmit(onSubmit)} className="p-4 rounded">
                        <div className="d-flex justify-content-center">
                            <img
                                style={{ width: "300px", height: "80px", objectFit: "contain" }}
                                src={require("./../../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp")}
                                className="img-fluid"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label text-white mb-3">کد ملی</label>
                            <input
                                type="text"
                                disabled
                                maxLength={10}
                                defaultValue={watch("nationalCode") || ""}
                                className={`form-control ${errors.nationalCode ? "border-danger" : ""}`}
                                {...register("nationalCode", { required: "کد ملی الزامی است" })}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label text-white mb-3">شماره موبایل</label>
                            <input
                                type="text"
                                disabled
                                maxLength={11}
                                defaultValue={watch("mobile") || ""}
                                className={`form-control ${errors.mobile ? "border-danger" : ""}`}
                                {...register("mobile", { required: "شماره موبایل الزامی است" })}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label text-white mb-3">تاریخ تولد</label>
                            <div>
                                {isMobile ? (
                                    <>
                                        <input
                                            type="text"
                                            readOnly
                                            value={selectedDateValue || ""}
                                            onClick={() => setShowPicker(true)}
                                            className={`form-control ${errors.birthDate ? "border-danger" : ""}`}
                                            placeholder="انتخاب تاریخ تولد"
                                            {...register("birthDate", { required: "تاریخ تولد الزامی است" })}
                                        />
                                        {showPicker && (
                                            <div className="d-flex justify-content-center mt-2">
                                                <Picker
                                                    isOpen={showPicker}
                                                    config={config}
                                                    minDate={newDate({ year: 1330, month: 1, day: 1 })}
                                                    maxDate={newDate({ year: 1410, month: 12, day: 30 })}
                                                    onChange={handleMobileSubmit}
                                                    onSubmit={() => setShowPicker(false)}
                                                    onClose={() => setShowPicker(false)}
                                                />
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <DatePicker
                                        value={selectedPcDate}
                                        onChange={handlePcDateChange}
                                        inputPlaceholder="انتخاب تاریخ تولد"
                                        inputClassName="form-control"
                                        shouldHighlightWeekends
                                        locale="fa"
                                        minimumDate={{ year: 1330, month: 1, day: 1 }}
                                        maximumDate={{ year: 1410, month: 12, day: 30 }}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label text-white mb-3">شماره کارت</label>
                            <input
                                type="text"
                                className={`form-control ${errors.cardNumber ? "border-danger" : ""}`}
                                {...register("cardNumber", { required: "شماره کارت الزامی است" })}
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn form-btn fw-bold rounded rounded-pill p-2 px-4 w-100 mt-4"
                            disabled={loading}
                        >
                            {loading ? "در حال ارسال..." : "ثبت"}
                        </button>
                    </form>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default LogAdmin;
